import React, { useEffect, useState } from 'react';
import { EyeIcon } from 'lucide-react';
export function LiveViewers() {
  const [viewers, setViewers] = useState(0);
  useEffect(() => {
    const base = Math.floor(Math.random() * 20) + 38;
    setViewers(base);
    const interval = setInterval(() => {
      setViewers(prev => {
        const change = Math.floor(Math.random() * 5) - 2;
        const next = prev + change;
        return Math.max(28, Math.min(75, next));
      });
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  if (viewers === 0) return null;
  return <div className="w-full bg-[#0a0a0a] border-b border-white/10 py-2 px-4" data-id="element-15">
      <div className="max-w-6xl mx-auto flex items-center justify-center gap-2 text-white text-xs font-medium" data-id="element-16">
        <span className="relative flex h-2 w-2" data-id="element-17">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-18" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-19" />
        </span>
        <EyeIcon className="w-3.5 h-3.5 text-white/70" aria-hidden="true" data-id="element-20" />
        <span data-id="element-21">
          <strong data-id="element-22">{viewers}</strong> pessoas vendo agora
        </span>
      </div>
    </div>;
}